import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSwap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M5.825 9.167L2.5 12.5l3.325 3.333v-2.5h5.842v-1.666H5.825v-2.5zM17.5 7.5l-3.325-3.333v2.5H8.333v1.666h5.842v2.5L17.5 7.5z"
	})
});
export default SvgIconSwap;
